// 9fbef606107a605d69c0edbcd8029e5d
import { CUSTOMER_HELP_ACTION_PATTERN } from '@tcp/core/src/constants/reducer.constants';

const CUSTOMER_HELP = 'customer-help';
const CUSTOMER_HELP_CONSTANTS = {
  GET_REFERRED_CONTENT: `${CUSTOMER_HELP_ACTION_PATTERN}GET_REFERRED_CONTENT`,
  SET_REFERRED_CONTENT: `${CUSTOMER_HELP_ACTION_PATTERN}SET_REFERRED_CONTENT`,
  SET_SELECTED_ITEMS: `${CUSTOMER_HELP_ACTION_PATTERN}SET_SELECTED_ITEMS`,
  SET_REASON_CODE: `${CUSTOMER_HELP_ACTION_PATTERN}SET_REASON_CODE`,
  SET_RESOLUTION_CODE: `${CUSTOMER_HELP_ACTION_PATTERN}SET_RESOLUTION_CODE`,
  CLEAR_REASON_CODE: `${CUSTOMER_HELP_ACTION_PATTERN}CLEAR_REASON_CODE`,
  CLEAR_SELECTED_RESOLUTION: `${CUSTOMER_HELP_ACTION_PATTERN}CLEAR_SELECTED_RESOLUTION`,
  SELECT_ORDER: `${CUSTOMER_HELP_ACTION_PATTERN}SELECT_ORDER`,
  TELL_US_MORE: `${CUSTOMER_HELP_ACTION_PATTERN}TELL_US_MORE`,
  CUSTOMER_HELP: 'customer-help',
  GET_ITEM_LEVEL_REFUND: `${CUSTOMER_HELP_ACTION_PATTERN}GET_ITEM_LEVEL_REFUND`,
  SET_ITEM_LEVEL_REFUND: `${CUSTOMER_HELP_ACTION_PATTERN}SET_ITEM_LEVEL_REFUND`,
  GET_SHIPMENT_STATUS: `${CUSTOMER_HELP_ACTION_PATTERN}GET_SHIPMENT_STATUS`,
  SET_SHIPMENT_STATUS: `${CUSTOMER_HELP_ACTION_PATTERN}SET_SHIPMENT_STATUS`,
  CLEAR_SELECTED_ITEMS: `${CUSTOMER_HELP_ACTION_PATTERN}CLEAR_SELECTED_ITEMS`,
  FETCH_RESOLUTION_MODULEX_CONTENT: `${CUSTOMER_HELP_ACTION_PATTERN}FETCH_RESOLUTION_MODULEX_CONTENT`,
  FETCH_CANCEL_MODULEX_CONTENT: `${CUSTOMER_HELP_ACTION_PATTERN}FETCH_CANCEL_MODULEX_CONTENT`,
  SET_RESOLUTION_MODULEX_CONTENT: `${CUSTOMER_HELP_ACTION_PATTERN}SET_RESOLUTION_MODULEX_CONTENT`,
  SET_CANCEL_RESOLUTION_MODULEX_CONTENT: `${CUSTOMER_HELP_ACTION_PATTERN}SET_CANCEL_RESOLUTION_MODULEX_CONTENT`,
  SHOW_CSH_LOADER: `${CUSTOMER_HELP_ACTION_PATTERN}SHOW_LOADER`,
  HIDE_CSH_LOADER: `${CUSTOMER_HELP_ACTION_PATTERN}HIDE_LOADER`,
  SET_WRONG_ITEM_STATE: `${CUSTOMER_HELP_ACTION_PATTERN}SET_WRONG_ITEM_STATE`,
  FETCH_TRANSIT_RESOLUTION_MODULEX_CONTENT: `${CUSTOMER_HELP_ACTION_PATTERN}FETCH_TRANSIT_RESOLUTION_MODULEX_CONTENT`,
  SET_TRANSIT_RESOLUTION_MODULEX_CONTENT: `${CUSTOMER_HELP_ACTION_PATTERN}SET_TRANSIT_RESOLUTION_MODULEX_CONTENT`,
  FETCH_RETURN_IN_STORE_MODULEX_CONTENT: `${CUSTOMER_HELP_ACTION_PATTERN}FETCH_RETURN_IN_STORE_MODULEX_CONTENT`,
  SET_RETURN_IN_STORE_MODULEX_CONTENT: `${CUSTOMER_HELP_ACTION_PATTERN}SET_RETURN_IN_STORE_MODULEX_CONTENT`,
  FETCH_RETURN_BY_MAIL_MODULEX_CONTENT: `${CUSTOMER_HELP_ACTION_PATTERN}FETCH_RETURN_BY_MAIL_MODULEX_CONTENT`,
  SET_RETURN_BY_MAIL_MODULEX_CONTENT: `${CUSTOMER_HELP_ACTION_PATTERN}SET_RETURN_BY_MAIL_MODULEX_CONTENT`,
  FETCH_RETURN_POLICY_MODULEX_CONTENT: `${CUSTOMER_HELP_ACTION_PATTERN}FETCH_RETURN_POLICY_MODULEX_CONTENT`,
  SET_RETURN_POLICY_MODULEX_CONTENT: `${CUSTOMER_HELP_ACTION_PATTERN}SET_RETURN_POLICY_MODULEX_CONTENT`,
  SET_REFUND_STATUS: `${CUSTOMER_HELP_ACTION_PATTERN}SET_REFUND_STATUS`,
  GET_REFUND_STATUS: `${CUSTOMER_HELP_ACTION_PATTERN}GET_REFUND_STATUS`,
  GET_CANCEL_STATUS: `${CUSTOMER_HELP_ACTION_PATTERN}GET_CANCEL_STATUS`,
  SET_CANCEL_STATUS: `${CUSTOMER_HELP_ACTION_PATTERN}SET_CANCEL_STATUS`,
  GET_SHIPMENT_DELAYED_REFUND: `${CUSTOMER_HELP_ACTION_PATTERN}GET_SHIPMENT_DELAYED_REFUND`,
  SET_SHIPMENT_DELAYED_REFUND: `${CUSTOMER_HELP_ACTION_PATTERN}SET_SHIPMENT_DELAYED_REFUND`,
  RESET_CUSTOMER_HELP_REDUCER: `${CUSTOMER_HELP_ACTION_PATTERN}RESET_CUSTOMER_HELP_REDUCER`,
  UPDATE_CURRENT_PAGE_NUMBER: `${CUSTOMER_HELP_ACTION_PATTERN}UPDATE_CURRENT_PAGE_NUMBER`,
  ORDER_STATUS_IN_TRANSIT: `${CUSTOMER_HELP_ACTION_PATTERN}ORDER_STATUS_IN_TRANSIT`,
  TOGGLE_CARDS: `${CUSTOMER_HELP_ACTION_PATTERN}TOGGLE_CARDS`,
  SET_SELECTED_SHIPMENT_CARD: `${CUSTOMER_HELP_ACTION_PATTERN}SET_SELECTED_SHIPMENT_CARD`,
  SET_FILTERED_LIST: `${CUSTOMER_HELP_ACTION_PATTERN}SET_FILTERED_LIST`,
  SET_SUMMARY: `${CUSTOMER_HELP_ACTION_PATTERN}SET_SUMMARY`,
  GET_REASON_CODES: `${CUSTOMER_HELP_ACTION_PATTERN}GET_REASON_CODES`,
  SET_REASON_CODES: `${CUSTOMER_HELP_ACTION_PATTERN}SET_REASON_CODES`,
  SET_ORDER_ARRIVE_REASON_CODE: `${CUSTOMER_HELP_ACTION_PATTERN}SET_ORDER_ARRIVE_REASON_CODE`,
  CLEAR_ORDER_ARRIVE_REASON_CODE: `${CUSTOMER_HELP_ACTION_PATTERN}CLEAR_ORDER_ARRIVE_REASON_CODE`,
  SET_INITIATE_RETURN_STATUS: `${CUSTOMER_HELP_ACTION_PATTERN}SET_INITIATE_RETURN_STATUS`,
  CLEAR_INITIATE_RETURN_STATUS: `${CUSTOMER_HELP_ACTION_PATTERN}CLEAR_INITIATE_RETURN_STATUS`,
  INITIATE_RETURN: `${CUSTOMER_HELP_ACTION_PATTERN}INITIATE_RETURN`,
  SET_RETURNED_ORDER_ITEMS: `${CUSTOMER_HELP_ACTION_PATTERN}SET_RETURNED_ORDER_ITEMS`,
  CLEAR_RETURNED_ORDER_ITEMS: `${CUSTOMER_HELP_ACTION_PATTERN}CLEAR_RETURNED_ORDER_ITEMS`,
  SET_ORDER_ARRIVE_DELIVERED_REASON_CODE: `${CUSTOMER_HELP_ACTION_PATTERN}SET_ORDER_ARRIVE_DELIVERED_REASON_CODE`,
  RETURN_METHOD: {
    IN_STORE: 'IN_STORE',
    BY_MAIL: 'BY_MAIL',
  },
};

export const CUSTOMER_HELP_PAGE_TEMPLATE = {
  LANDING_PAGE: '',
  SELECT_ORDER: 'select-order',
  TELL_US_MORE: 'tell-us-more',
  REVIEW: 'review',
  CONFIRMATION: 'confirmation',
  ACCOUNT_COUPONS: 'account-and-coupons',
  ADD_PICKUP_PERSON: 'add-pickup',
  ORDER_SIZE: 5,
};
export const CUSTOMER_HELP_DIRECT_LINK_TEMPLATE = {
  COUPON_ISSUE: 'coupon_issue',
  MERGE_MYPLACE_ACCOUNTS: 'MERGE_MYPLACE_ACCOUNTS',
};

export const REASON_CODES = {
  WHEN_WILL_MY_ORDER_ARRIVE: 'WHEN_WILL_MY_ORDER_ARRIVE',
  PAID_SHIPPING_BUT_NOT_RECEIVED_ON_TIME: 'SHIPMENT_DELAYED',
  TRACKING_NUMBER_SHOW_IN_TRANSIT_FOR_LONG_TIME: 'IN_TRANSIT',
  MISSING_ORDER: 'ITEM_MISSING',
  PACKAGE_DELIVERED_BUT_NOT_RECEIVED: 'LOST_ORDER',
  RECEIVED_WRONG_ITEM: 'WRONG_ITEMS',
  RECEIVED_SOMEONE_ORDER: 'RECEIVED_SOMEONE_ORDER',
  SOMETHING_ELSE: 'SOMETHING_ELSE',
  CANCEL_MODIFY: 'CANCEL_MODIFY',
  COUPON_ISSUE: 'COUPON_ISSUE',
  EXISTING_ORDER: 'EXISTING_ORDER',
  MERGE_MYPLACE_ACCOUNTS: 'MERGE_MYPLACE_ACCOUNTS',
  ACCOUNT_AND_COUPONS: 'ACCOUNT_AND_COUPONS',
  INITIATE_RETURN: 'RETURN_ITEMS',
  RETURN_ITEMS: 'RETURN_ITEMS',
};

export const LIVECHAT_SESSION_KEYS = {
  REASON_CODE: 'reasonCode',
  INITIATE_LIVE_CHAT: 'initiateLiveChat',
  ORDER_NUMBER: 'orderNumber',
  EMAIL_ADDRESS: 'emailID',
  CUSTOMER_SCORE: 'customerScore',
  ITEM_NUMBERS: 'itemNumbers',
  SELECTED_ITEMS: 'selectedItems',
  COUPON_NUMBER: 'couponNumber',
  ORDER_TOTAL: 'orderTotal',
  RETURN_METHOD: 'returnMethod',
  ERROR_CODE: 'DOMErrorCode',
};

export const FILTERED_REASON_CODES_ON_SHIPPMENT_STATUS = {
  IN_PROGRESS_ACTIONS: [
    REASON_CODES.WHEN_WILL_MY_ORDER_ARRIVE,
    REASON_CODES.CANCEL_MODIFY,
    REASON_CODES.SOMETHING_ELSE,
  ],
  IN_TRANSIT_ACTIONS: [
    REASON_CODES.WHEN_WILL_MY_ORDER_ARRIVE,
    REASON_CODES.TRACKING_NUMBER_SHOW_IN_TRANSIT_FOR_LONG_TIME,
    REASON_CODES.SOMETHING_ELSE,
  ],
  DELIVERY_ACTIONS: [
    REASON_CODES.MISSING_ORDER,
    REASON_CODES.RECEIVED_WRONG_ITEM,
    REASON_CODES.PACKAGE_DELIVERED_BUT_NOT_RECEIVED,
    REASON_CODES.SOMETHING_ELSE,
    REASON_CODES.INITIATE_RETURN,
  ],
  RUSH_EXPRESS_ACTIONS: [REASON_CODES.PAID_SHIPPING_BUT_NOT_RECEIVED_ON_TIME],
  ORDER_NOT_FOUND: [REASON_CODES.SOMETHING_ELSE],
};

export const FILTERED_REASON_CODES_ON_ORDER_ARRIVE = {
  MY_ORDER_ARRIVE_TRANSIT_ACTIONS: [
    REASON_CODES.TRACKING_NUMBER_SHOW_IN_TRANSIT_FOR_LONG_TIME,
    REASON_CODES.SOMETHING_ELSE,
  ],
};

export const CUSTOMER_HELP_ROUTES = {
  SELECT_ORDER: {
    to: `/${CUSTOMER_HELP}?section=${CUSTOMER_HELP_PAGE_TEMPLATE.SELECT_ORDER}`,
    asPath: `/${CUSTOMER_HELP}/${CUSTOMER_HELP_PAGE_TEMPLATE.SELECT_ORDER}`,
  },
  TELL_US_MORE: {
    to: `/${CUSTOMER_HELP}?section=${CUSTOMER_HELP_PAGE_TEMPLATE.TELL_US_MORE}`,
    asPath: `/${CUSTOMER_HELP}/${CUSTOMER_HELP_PAGE_TEMPLATE.TELL_US_MORE}`,
  },
  REVIEW: {
    to: `/${CUSTOMER_HELP}?section=${CUSTOMER_HELP_PAGE_TEMPLATE.REVIEW}`,
    asPath: `/${CUSTOMER_HELP}/${CUSTOMER_HELP_PAGE_TEMPLATE.REVIEW}`,
  },
  CONFIRMATION: {
    to: `/${CUSTOMER_HELP}?section=${CUSTOMER_HELP_PAGE_TEMPLATE.CONFIRMATION}`,
    asPath: `/${CUSTOMER_HELP}/${CUSTOMER_HELP_PAGE_TEMPLATE.CONFIRMATION}`,
  },
  LANDING_PAGE: {
    to: `/${CUSTOMER_HELP}`,
    asPath: `/${CUSTOMER_HELP}`,
  },
  ACCOUNT_COUPONS: {
    to: `/${CUSTOMER_HELP}?section=${CUSTOMER_HELP_PAGE_TEMPLATE.ACCOUNT_COUPONS}`,
    asPath: `/${CUSTOMER_HELP}/${CUSTOMER_HELP_PAGE_TEMPLATE.ACCOUNT_COUPONS}`,
  },
  ADD_PICKUP_PERSON: {
    to: `/${CUSTOMER_HELP}?section=${CUSTOMER_HELP_PAGE_TEMPLATE.ADD_PICKUP_PERSON}`,
    asPath: `/${CUSTOMER_HELP}/${CUSTOMER_HELP_PAGE_TEMPLATE.ADD_PICKUP_PERSON}`,
  },
};
export const CUSTOMER_HELP_DIRECT_ROUTES = {
  COUPON_ISSUE: {
    to: `/${CUSTOMER_HELP}?section=${CUSTOMER_HELP_PAGE_TEMPLATE.ACCOUNT_COUPONS}&reasonCode=${CUSTOMER_HELP_DIRECT_LINK_TEMPLATE.COUPON_ISSUE}`,
    asPath: `/${CUSTOMER_HELP}/${CUSTOMER_HELP_PAGE_TEMPLATE.ACCOUNT_COUPONS}/${CUSTOMER_HELP_DIRECT_LINK_TEMPLATE.COUPON_ISSUE}`,
  },
  MERGE_MYPLACE_ACCOUNTS: {
    to: `/${CUSTOMER_HELP}?section=${CUSTOMER_HELP_PAGE_TEMPLATE.ACCOUNT_COUPONS}&reasonCode=${CUSTOMER_HELP_DIRECT_LINK_TEMPLATE.MERGE_MYPLACE_ACCOUNTS}`,
    asPath: `/${CUSTOMER_HELP}/${CUSTOMER_HELP_PAGE_TEMPLATE.ACCOUNT_COUPONS}/${CUSTOMER_HELP_DIRECT_LINK_TEMPLATE.MERGE_MYPLACE_ACCOUNTS}`,
  },
};

export const getAvailableStages = () => [
  CUSTOMER_HELP_PAGE_TEMPLATE.SELECT_ORDER,
  CUSTOMER_HELP_PAGE_TEMPLATE.TELL_US_MORE,
  CUSTOMER_HELP_PAGE_TEMPLATE.REVIEW,
];

export const missingOrWrongItemsResolutionConst = {
  refundItems: 'refundItems',
  resendItemWithFreeShipping: 'resendItemWithFreeShipping',
  connectWithCustomerSpecialist: 'connectWithCustomerSpecialist',
};

export const delayedResolutionConst = {
  refundShippingFee: 'refundShippingFee',
  connectWithCustomerSpecialist: 'connectWithCustomerSpecialist',
};

export const connectWithSpecialistResolution = {
  connectWithCustomerSpecialist: 'lbl_connect_with_customer_service_specialist',
};

export const cancelNModifyResolutionConst = {
  cancelOrder: 'cancelOrder',
  modifyOrder: 'modifyOrder',
  connectWithCustomerSpecialist: 'connectWithCustomerSpecialist',
};

export const wrongItemsResolutionConst = {
  receiveDifferentItem: 'receiveDifferentItem',
  receiveWrongColorItem: 'receiveWrongColorItem',
  receiveWrongSizeItem: 'receiveWrongSizeItem',
  somethingElse: 'somethingElse',
};

export const shipmentResolutionConst = {
  refundShipment: 'refundShipment',
  resendShipmentWithFreeShipping: 'resendShipmentWithFreeShipping',
  connectWithCustomerSpecialist: 'connectWithCustomerSpecialist',
};

export const ORDER_ITEM_STATUS = {
  SHIPPED: 'Order Shipped',
  RETURNED: 'Order Returned',
  CANCELLED: 'Order Cancelled',
  CANCELED: 'Order Canceled',
  ITEM_REFUNDED: 'item refunded',
  REFUNDED: 'Refunded',
  IN_TRANSIT: 'In-transit',
  TRANSIT: 'In Transit',
  DELIVERED: 'order shipped',
  SHIPMENT_API_DELIVERED: 'Delivered',
  IN_PROGRESS: 'In-Progress',
  ORDER_BEING_PROCESSED: 'Order Being Processed',
  RETURN_INITIATED: 'Return Initiated',
  RETURN_COMPLETED: 'Return Completed',
  ORDER_PROCESSING: 'processing',
  ORDER_BEING_PROCESED: 'order being processed',
  ORDER_IN_PROCESS: 'order in process',
  NonEligibleForReturn: 'Non Eligible For Return',
  GIFT_ITEM: 'Gift Item',
  FINAL_SALE_PRODUCT: `Final Sale Product`,
};

export const ORDER_STATUS = {
  ORDER_BEING_PROCESSED: 'order being processed',
  SHIPPED: 'shipped',
  PARTIALLY_SHIPPED: 'partially shipped',
  PARTIALLY_DELIVERED: 'partially delivered',
  DELIVERED: 'delivered',
  ORDER_PARTIALLY_SHIPPED: 'order partially shipped',
};

export const SHIPPING_METHOD_STATUS = {
  RUSH: 'Rush',
  EXPRESS: 'Express',
};

export const reasonWrongItemsResolution = {
  receiveDifferentItem: 'lbl_receive_different_order',
  receiveWrongColorItem: 'lbl_receive_wrong_color_order',
  receiveWrongSizeItem: 'lbl_receive_wrong_size_order',
  somethingElse: 'lbl_something_else',
};

export const SHIPMENT_METHODS = {
  STANDARD: 'standard',
  GROUND: 'ground',
};

export const missingOrWrongItemsResolution = {
  refundItems: 'lbl_refund_items',
  resendItemWithFreeShipping: 'lbl_resend_with_free_shipping',
  connectWithCustomerSpecialist: 'lbl_connect_with_customer_service_specialist',
};

export const delayedResolution = {
  refundShippingFee: 'lbl_refund_shipping_fee',
  connectWithCustomerSpecialist: 'lbl_connect_with_customer_service_specialist',
};

export const cancelNModifyResolution = {
  cancelOrder: 'lbl_cancel_order',
  modifyOrder: 'lbl_modify_order',
  connectWithCustomerSpecialist: 'lbl_connect_with_customer_service_specialist',
};

export const shipmentResolution = {
  refundShipment: 'lbl_refund_shipment',
  resendShipmentWithFreeShipping: 'lbl_resend_shipment_with_free_shipping',
  connectWithCustomerSpecialist: 'lbl_connect_with_customer_service_specialist',
};
export const whenWillMyOrderArriveResolution = {};

export const PRODUCT_IMAGE_WIDTH = 79;
export const PRODUCT_IMAGE_HEIGHT = 91;

export const REFUND_UNDER_REVIEW_LABELS_MAPPING = {
  REFUND_OFF: 'lbl_help_refund_under_review_refund_off',
  GC_IN_ORDER: 'lbl_help_refund_under_review_gc_in_order',
  NOT_ELIGIBLE: 'lbl_help_refund_under_review_not_eligible',
  SOMETHING_ELSE: 'lbl_help_refund_under_review_something_else',
};

const ORDER_HELP = 'Order Help';

export const CUSTOMER_HELP_GA = {
  HEADER_LINK_TRACK: {
    eventName: ORDER_HELP,
    CD126: 'Global Header',
  },
  BANNER_CTA_TRACK: {
    eventName: ORDER_HELP,
    CD126: 'Help Center',
  },
  HELP_NAV_TRACK: {
    eventName: ORDER_HELP,
    CD126: 'Help Navigation',
  },
  HELP_DRAWER_TRACK: {
    eventName: ORDER_HELP,
    CD126: 'Order Help Drawer',
  },
};

export const REFUND_UNDER_REVIEW = 'REFUND_UNDER_REVIEW';
export const GC_IN_ORDER = 'GC_IN_ORDER';

export const BRAND_ID = {
  TCP: 'tcp',
  GYMBOREE: 'gym',
  PJPLACE: 'pjp',
  SNJ: 'snj',
};

export const AFTERPAY = 'AFTERPAY';

export const GENERIC_ERROR = 'Oh no! Something went wrong… Please try again in a few minutes.';

// The redux state key for different readon codes in CustomerHelp.reducer
export const REASON_CODES_REDUX_KEY = {
  TELL_US_MORE_REASON_CODES: 'reasonCodes',
  ACCOUNT_COUPONS_REASON_CODES: 'accountsCouponsReasonCodes',
  TOP_LEVEL_REASON_CODES: 'topLevelReasonCodes',
};

// The indices for diffrent reason code division tab referred content in the referred field of global.helpCenter labels
export const REASON_CODES_REFERRED_INDEX = {
  TELL_US_MORE_REASON_CODES: 0,
  ACCOUNT_COUPONS_REASON_CODES: 4,
  TOP_LEVEL_REASON_CODES: 5,
};

export const RETURN_ITEM_CONSTANT = {
  SET_RETURN_METHOD: 'SET_RETURN_METHOD',
  GET_RETURN_METHOD: 'GET_RETURN_METHOD',
  CLEAR_RETURN_METHOD: 'CLEAR_RETURN_METHOD',
  IS_RETURN_ITEM_DISPLAY: 'IS_RETURN_ITEM_DISPLAY',
};

export const CSH_PAGE_TARGET_FOR_HELPCENTER = 'cshLanding';

export const INITIATE_RETURN_SUCCESS_STATUS = 'RETURN_INITIATED';

export default CUSTOMER_HELP_CONSTANTS;
